export default __webpack_public_path__ + "static/media/arrow.6d4ae74b.svg";